import React from 'react';
import './SmsConsentDisclosure.css';

const SmsConsentDisclosure: React.FC = () => (
  <div className="sms-consent-disclosure">
    <p className="sms-consent-disclosure-primary">
      By providing your phone, you agree to receive SMS verification codes from TradeMagic.
    </p>
    <p className="sms-consent-disclosure-fineprint">
      Msg frequency varies. Msg &amp; data rates may apply. Reply STOP to unsubscribe, HELP for help. See{' '}
      <a href="/privacy" target="_blank" rel="noopener noreferrer">
        Privacy Policy
      </a>
      .
    </p>
  </div>
);

export default SmsConsentDisclosure;
